//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
import { withRouter } from 'react-router';
import { NavLink, Link as RouterLink } from 'react-router-dom';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
import * as mobilemenustyles from './mobilemenu.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { Button, Logo, ViewRecommendationsButton } from '@cmp/common';
import { Menu } from './common';
//------------------------------------------------------------------------------
// Constants -------------------------------------------------------------------

//------------------------------------------------------------------------------
// Assets ----------------------------------------------------------------------
import {
  dashboardIconUrl,
  shoppingCartIconUrl,
  MenuIcon,
  HamburgerIcon,
  LensIcon,
  CloseBlueIcon,
  PersonIcon,
  ExternalLinkIcon,
} from '@cmp/images';
import { FooterSection } from '@cmp/common';
//------------------------------------------------------------------------------
// Helpers ---------------------------------------------------------------------
import { withAuthUser } from '@helpers/auth';
import { withReferral } from '@helpers/referrals';
import { handleGtmEvent } from '@helpers/gtm';
import { completedRegistration } from '@helpers/account';
import { deauth } from '@helpers/auth';
import { getValue } from '@helpers/localStorage';
// API -------------------------------------------------------------------------
import { Providers as ProvidersRequest } from '@api/endpoints/get/providers';
//------------------------------------------------------------------------------
// Constants -------------------------------------------------------------------
import { PayoutOption } from '@helpers/constants/user';
import { refCode, IsAdminApproved } from '@helpers/constants/localStorage';
import { withTranslation } from 'react-i18next';
import { StoreConfigContext } from '@helpers/storeConfigContext.jsx';

//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggle: false,
      anchorEl: null,
      isMenuVisible: null,
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.setToggle = this.setToggle.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(event) {
    const { anchorEl } = this.state;

    if (
      anchorEl &&
      this.wrapperRef &&
      !this.wrapperRef.contains(event.target)
    ) {
      this.setState({ anchorEl: null });
    }
  }

  pagesComponent() {
    const { __authUser, t, i18n } = this.props;
    const { toggle } = this.state;
    const { handleToggle } = this;
    const { setToggle } = this;
    const componentClasses = classNames(mobilemenustyles.MobileMenu);

    return (
      <div className={styles.Menu}>
        <div className={componentClasses}></div>
        <span className={styles.MenuTitle}></span>
        {__authUser && completedRegistration(__authUser) && (
          <span
            className={styles.DesktopMenu + ' ' + styles.MobileMenu}
            onClick={setToggle}
          >
            <div className={styles.Options}>
              {this.menuOptionComponent(
                dashboardIconUrl(i18n),
                t('header_Dashboard'),
                '/recommendations'
              )}
              {this.menuOptionComponent(
                shoppingCartIconUrl(i18n),
                t('header_RecommendedProducts'),
                '/'
              )}
              {this.menuOptionComponent(
                shoppingCartIconUrl(i18n),
                t('header_About'),
                '/about'
              )}
              {this.menuOptionComponent(
                shoppingCartIconUrl(i18n),
                t('header_Support'),
                '/support'
              )}
            </div>
          </span>
        )}
      </div>
    );
  }

  handleClick(event, title, to = '', allPagesDropdown, noLogin) {
    const { t } = this.props;
    let clickUrl;
    if (event.target.parentNode.tagName.toLowerCase() === 'a') {
      clickUrl = event.target.parentNode.href;
    } else {
      clickUrl = to || event.target?.href;
    }

    const getClickText = (eventTarget) => {
      // check if element contains text label
      if (eventTarget.childNodes[0].nodeType === Node.TEXT_NODE) {
        return eventTarget.innerHTML;
      }
      // if element does not contain text label, recurse until text label
      if (eventTarget.childNodes[0].nodeType !== Node.TEXT_NODE) {
        return getClickText(eventTarget.childNodes[0]);
      }
    };

    const clickText = allPagesDropdown
      ? getClickText(event.target)
      : title || clickTextNoLogin;

    // logout GA4 event is handled in auth.js
    if (clickText === t('header_Logout')) {
      return;
    }

    const clickTextNoLogin = noLogin && event.target.firstChild.textContent;
    handleGtmEvent('navigation', {
      eventParameters: {
        omnibus: true,
        nav_group: 'mainnav',
        click_text: clickText,
        click_url: clickUrl,
      },
    });
  }

  menuOptionComponent(icon, title, to) {
    return (
      <NavLink
        exact
        className={styles.MenuOption}
        activeClassName={styles.MenuOptionActive}
        to={to}
        onClick={(event) => this.handleClick(event, title, to)}
      >
        <span className={styles.Title}>{title}</span>
      </NavLink>
    );
  }

  recommendationsComponent() {}

  userInfoComponent() {
    const { __authUser, pendingApproval, t } = this.props;

    if (!__authUser || pendingApproval) {
      return <></>;
    }

    return (
      <div className={styles.UserInfo} ref={(node) => (this.wrapperRef = node)}>
        <div
          tabIndex={0}
          className={styles.UserIcon}
          onClick={({ target }) => this.setState({ anchorEl: target })}
          onFocus={({ target }) => this.setState({ anchorEl: target })}
        >
          <PersonIcon alt={t('header_UserInfo')} />
        </div>
        {this.allPagesComponent()}
      </div>
    );
  }

  providerCodeComponent() {
    const { __authUser, location, t } = this.props;
    const { anchorEl } = this.state;
    const componentClasses = classNames(styles.Menu, {
      [styles.Options]: !anchorEl,
    });
    const referralCode = getValue(refCode);
    const isAdminApproved = getValue(IsAdminApproved, true);

    const {
      storeConfig: { payoutOption },
    } = this.context;
    const profCodeEnabled = isAdminApproved;

    return (
      <div>
        {profCodeEnabled && (
          <RouterLink
            to={{
              pathname: '/recommendation/professional-code-share',
              state: { from: location, modal: true },
            }}
            onClick={() => this.setState({ anchorEl: null })}
            className={styles.MenuOption}
          >
            <span className={styles.Title}>
              {t('header_ShareYourCode', { code: referralCode })}
            </span>
          </RouterLink>
        )}
      </div>
    );
  }

  allPagesComponent() {
    const { __authUser, location, t } = this.props;
    const { anchorEl } = this.state;
    const componentClasses = classNames(styles.UserInfoMenu, {
      [styles.Hidden]: !anchorEl,
    });

    const HeaderPages = [
      {
        i18nTitleKey: 'header_Account',
        pathname: '/myaccount',
      },
      {
        i18nTitleKey: 'header_Quickreco',
        requiresAuthentication: true,
      },
      {
        i18nTitleKey: 'header_Logout',
        onClick: () => deauth(),
        requiresAuthentication: true,
        handleFocusAction: true,
      },
    ];

    const isAdminApproved = getValue(IsAdminApproved, true);

    const {
      storeConfig: { payoutOption },
      featureFlags: { useEUQuickReco, loyaltyProgram },
    } = this.context;
    const appUrl = window.location.href;

    const profCodeEnabled = isAdminApproved;
    const referralCode = getValue(refCode);

    return (
      <div
        className={componentClasses}
        onClick={(event) => {
          this.handleClick(event, undefined, undefined, true);
        }}
      >
        {profCodeEnabled && (
          <ProvidersRequest skip={!!referralCode}>
            {({ data, refetch }) => {
              this.refetch = refetch;

              const normRefCode =
                referralCode || (data && data.referralCode) || '';

              return (
                <RouterLink
                  tabIndex="0"
                  to={{
                    pathname: '/recommendation/professional-code-share',
                    state: { from: location, modal: true },
                  }}
                  onClick={() => this.setState({ anchorEl: null })}
                  className={styles.MenuOption}
                  onKeyDown={(target) => {
                    if (target.key === 'Enter')
                      this.setState({ anchorEl: null });
                  }}
                >
                  {t('header_ShareYourCode', {
                    code: normRefCode,
                  })}
                </RouterLink>
              );
            }}
          </ProvidersRequest>
        )}
        {HeaderPages.map((item) => {
          if (
            item.requiresCompleteRegistration &&
            (!__authUser || !completedRegistration(__authUser))
          ) {
            return null;
          }

          if (item.requiresAuthentication && !__authUser) {
            return null;
          }

          if (item.i18nTitleKey == 'header_Quickreco') {
            if (
              useEUQuickReco &&
              loyaltyProgram &&
              import.meta.env.VITE_QUICK_RECO_URL
            ) {
              return (
                <a
                  href={import.meta.env.VITE_QUICK_RECO_URL}
                  className={styles.MenuOption}
                  target="_blank"
                  onClick={() => this.setState({ anchorEl: null })}
                  key={item.i18nTitleKey}
                  tabIndex={0}
                >
                  <span className={styles.Title}> {t(item.i18nTitleKey)}</span>
                  <span className={styles.ExternalLinkIcon}>
                    <ExternalLinkIcon />
                  </span>
                </a>
              );
            } else {
              return null;
            }
          }

          if (item.i18nTitleKey == 'header_PatientLogin') {
            return (
              <span
                className={styles.MenuOption}
                onClick={item.onClick}
                key={item.i18nTitleKey}
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter')
                    window.location.href =
                      import.meta.env.VITE_SHOPIFY_PUBLIC_URL;
                }}
              >
                {t(item.i18nTitleKey)}
              </span>
            );
          }

          if (item.i18nTitleKey == 'header_Logout') {
            return (
              <span
                className={styles.MenuOption}
                onClick={item.onClick}
                key={item.i18nTitleKey}
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') deauth();
                }}
                onBlur={() => this.setState({ anchorEl: null })}
              >
                {t(item.i18nTitleKey)}
              </span>
            );
          }

          if (item.pathname) {
            return (
              <NavLink
                to={item.pathname}
                className={styles.MenuOption}
                onClick={() => this.setState({ anchorEl: null })}
                activeClassName={styles.MenuOptionActive}
                key={item.i18nTitleKey}
                tabIndex={0}
                onKeyPress={(target) => {
                  if (target.key === 'Enter') this.setState({ anchorEl: null });
                }}
              >
                <span className={styles.Title}> {t(item.i18nTitleKey)}</span>
              </NavLink>
            );
          }

          return (
            <span
              className={styles.MenuOption}
              onClick={item.onClick}
              key={item.i18nTitleKey}
              tabIndex={0}
            >
              {t(item.i18nTitleKey)}
            </span>
          );
        })}
      </div>
    );
  }

  responsiveMenuComponent() {
    const { location } = this.props;
    const { isMenuVisible } = this.state;

    return (
      <div className={styles.ResponsiveMenu}>
        <MenuIcon
          className={styles.Icon}
          onClick={() => this.setState({ isMenuVisible: true })}
        />
        <Menu
          isVisible={isMenuVisible}
          location={location}
          onClose={() => this.setState({ isMenuVisible: false })}
        />
      </div>
    );
  }
  setToggle() {
    this.setState((state) => ({ toggle: false }));
  }
  handleToggle() {
    this.setState((state) => ({ toggle: !this.state.toggle }));
  }
  registrationButtonComponent() {
    const { t, __authUser, pendingApproval, toggle, onToggle } = this.props;

    if (__authUser) {
      const { handleToggle } = this;
      const { toggle } = this.state;
      return (
        <div className={styles.RegistrationButtonGroup}>
          <div className={styles.RegistrationButtonGroupMobile}>
            <LensIcon className={styles.Link} />
            <div onClick={handleToggle}>
              {toggle ? (
                <CloseBlueIcon className={styles.Link} />
              ) : (
                <HamburgerIcon className={styles.Link} />
              )}
            </div>
          </div>
        </div>
      );
    }

    return (
      <div
        className={styles.RegistrationButtonGroup}
        onClick={(event) =>
          this.handleClick(event, undefined, undefined, undefined, true)
        }
      >
        <div className={styles.RegistrationButtonGroupMobile}>
          <LensIcon className={styles.Link} />
          {toggle ? (
            <CloseBlueIcon className={styles.Link} onClick={onToggle} />
          ) : (
            <HamburgerIcon className={styles.Link} onClick={onToggle} />
          )}
        </div>
        <div className={styles.RegistrationButtonGroupDesktop}>
          {!pendingApproval && (
            <Button to="/signup" className={styles.RegisterBtn}>
              <a href="/signup">{t('landing_Register')}</a>
            </Button>
          )}
          <NavLink
            exact
            className={styles.Link}
            activeClassName={styles.LinkOptionActive}
            to="/about"
          >
            <span className={styles.Title}>{t('header_About')}</span>
          </NavLink>

          <NavLink
            exact
            className={styles.Link}
            activeClassName={styles.LinkOptionActive}
            to="/support"
          >
            <span className={styles.Title}>{t('header_Support')}</span>
          </NavLink>
        </div>
      </div>
    );
  }

  render() {
    const { className, t, __authUser } = this.props;
    const componentClasses = classNames(styles.Header, {});

    return (
      <div className={componentClasses}>
        <div className={styles.Content}>
          <div
            className={styles.Left}
            onClick={(event) => this.handleClick(event, t('header_Logo'))}
          >
            <Logo className={styles.Logo} />
          </div>
          <div
            className={
              styles.noLogin +
              ' ' +
              (__authUser ? styles.authUser : styles.noauthUser)
            }
          >
            {this.registrationButtonComponent()}
          </div>
          <div
            className={
              styles.Right +
              ' ' +
              (this.state.toggle
                ? styles.mobileMenuList
                : styles.mobileMenuhide)
            }
          >
            {this.pagesComponent()}
            <ViewRecommendationsButton className={styles.Recommendations} />
            {this.userInfoComponent()}
            <div className={styles.UserLoginMobile}>
              {this.allPagesComponent()}
              {this.state.toggle ? <FooterSection /> : <div />}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withRouter(
  withAuthUser(withReferral(withTranslation()(Header)))
);
Header.contextType = StoreConfigContext;
